export const TIPOS_EQUIPO = [
  'Desktop',
  'Laptop',
  'Monitor',
  'UPS',
  'Periféricos',
  'No Break',
  'Otro'
];
export default TIPOS_EQUIPO;